<template>
  <div :style="height"></div>
</template>

<script>
export default {
  props: [
    'by',
  ],
  computed: {
    height() {
      return {
        'margin-top': `${this.by}em`,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Shared/Spacer.vue